import { render } from "./OfferDocIndex.vue?vue&type=template&id=5f660617"
import script from "./OfferDocIndex.vue?vue&type=script&lang=js"
export * from "./OfferDocIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__